<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-toolbar text color="white">
        <v-toolbar-title>Clientes</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="brown lighten-1 mx-1" fab small dark @click.native="listar()">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn class="blue mx-1" fab small dark @click.native="print()">
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn class="deep-orange darken-3 mx-1" fab small dark @click.native="abrirNuevoCliente">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="clientes"
        :items-per-page="50"
        sort-by="codigo"
        :search="filtros.otros"
        item-key="_id"
        class="elevation-1"
        :footer-props="{
                            itemsPerPageOptions: [15,50,100,-1]
                        }"
      >
        <template v-slot:top>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs2 sm2 md2>
                <v-text-field v-model="filtros.codigo_cliente" type="number" label="Cód. Cliente"></v-text-field>
              </v-flex>
              <v-flex xs8 sm8 md8>
                <v-text-field
                  v-model="filtros.otros"
                  append-icon="search"
                  label="Nombre o remitente"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-icon class="mt-2" @click="limpiarFiltros()" color="red">clear</v-icon>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn class="green mx-1" fab small dark @click.native="exportarClientes2Excel">
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
        <template v-slot:item.accion="{ item }">
          <v-icon small class="mr-2" @click="editarCliente(item)">edit</v-icon>
          <v-icon small class="mr-2" @click="confirmarEliminarCliente(item)">delete</v-icon>
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm2 md2>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.codigo"
                    label="*Código"
                    type="Number"
                    min="1"
                    step="1"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.nombre_comercial"
                    label="*Nombre Comercial"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.uid_WSTransportista.gls"
                    label="*UID GLS"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.nombre"
                    label="*Remitente"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.direccion"
                    label="*Dirección"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.poblacion"
                    label="*Población"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 sm3 md3>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.cp"
                    label="*Código Postal"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm9 md9>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.provincia"
                    label="Provincia"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.telefono"
                    label="Teléfono"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.movil"
                    label="Móvil"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.email"
                    label="Email"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.departamento"
                    label="Departamento"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.nif"
                    label="Nif"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="cliente.remite.observaciones"
                    label="Observaciones"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 v-show="!!validaMensaje.length">
                  <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrar">Cancelar</v-btn>
            <v-btn v-if="creando" color="primary darken-1" @click="insertarCliente">Insertar</v-btn>
            <v-btn
              v-else-if="!eliminando"
              color="primary darken-1"
              @click="actualizarCliente"
            >Actualizar</v-btn>
            <v-btn v-else color="primary darken-1" @click="eliminarCliente">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import XLSX from "xlsx";

const CREANDO = 1;
const EDITANDO = 2;
const ELIMINANDO = 3;

export default {
  data() {
    return {
      dialog: false,
      filtros: {
        codigo_cliente: "",
        otros: ""
      },
      clientes: [],
      headers: [
        {
          text: "Código",
          value: "codigo",
          align: "center",
          sortable: false,
          filter: value => {
            if (!this.filtros.codigo_cliente) {
              return true;
            }
            return value == parseInt(this.filtros.codigo_cliente);
          }
        },
        { text: "Nombre Comercial", value: "nombre_comercial", sortable: true },
        { text: "Remitente", value: "remite.nombre", sortable: true },
        { text: "Acciones", value: "accion", align: "center", sortable: false }
      ],
      cliente: {
        _id: "",
        codigo: "",
        uid_WSTransportista: {
          gls: ""
        },
        nombre_comercial: "",
        remite: {
          direccion: "",
          poblacion: "",
          provincia: "",
          cp: "",
          telefono: "",
          movil: "",
          email: "",
          departamento: "",
          nif: "",
          observaciones: ""
        }
      },
      validaMensaje: [],
      accion: CREANDO
    };
  },
  computed: {
    formTitle() {
      console.log(
        "formTitle this.creando",
        this.creando
          ? "Nuevo registro"
          : this.eliminando
          ? "Eliminar registro"
          : "Editar registro"
      );
      switch (this.accion) {
        case CREANDO:
          return "Nuevo registro";
        case EDITANDO:
          return "Editar registro";
        case ELIMINANDO:
          return "Eliminar registro";
      }
      console.log("No coge el switch");
      return this.creando
        ? "Nuevo registro"
        : this.eliminando
        ? "Eliminar registro"
        : "Editar registro";
    },
    creando() {
      console.log("creando this.accion", this.accion);
      console.log("CREANDO", CREANDO);
      return this.accion == CREANDO;
    },
    editando() {
      console.log("editando this.accion", this.accion);
      console.log("EDITANDO", EDITANDO);
      return this.accion == EDITANDO;
    },
    eliminando() {
      console.log("eliminando this.accion", this.accion);
      console.log("ELIMINANDO", ELIMINANDO);
      return this.accion == ELIMINANDO;
    }
  },
  watch: {
    dialog(val) {
      val || this.cerrar();
    },
    validaMensaje(val) {
      console.log("watch validaMensaje", val);
      if (val.length > 0 && !this.dialog) {
        this.$alert(val[0]);
      }
    }
  },
  created() {
    this.listar();
  },
  methods: {
    print() {
      window.print();
    },
    limpiarFiltros() {
      console.log("limpiarFiltros");
      this.filtros.codigo_cliente = "";
      this.filtros.otros = "";
    },
    limpiar() {
      this.cliente = {
        _id: "",
        codigo: "",
        uid_WSTransportista: {
          gls: ""
        },
        nombre_comercial: "",
        remite: {
          nombre: "",
          direccion: "",
          poblacion: "",
          provincia: "",
          cp: "",
          telefono: "",
          movil: "",
          email: "",
          departamento: "",
          nif: "",
          observaciones: ""
        }
      };
      this.validaMensaje = [];
      this.accion = CREANDO;
    },
    esValido() {
      this.validaMensaje = [];
      if (!this.cliente.codigo) {
        this.validaMensaje.push("Código cliente (máx. 6 dígitos)");
      }
      if (!this.cliente.nombre_comercial) {
        this.validaMensaje.push("Nombre Comercial (máx. 64 caracteres)");
      }
      if (!this.cliente.uid_WSTransportista.gls) {
        this.validaMensaje.push(
          "UID GLS (36 caracteres. Ej: 6BAB7A53-3B6D-4D5A-9450-702D2FAC0B11)"
        );
      }
      if (!this.cliente.remite.nombre) {
        this.validaMensaje.push("Remitente (máx. 80 caracteres)");
      }
      if (!this.cliente.remite.direccion) {
        this.validaMensaje.push("Dirección (máx. 80 caracteres)");
      }
      if (!this.cliente.remite.poblacion) {
        this.validaMensaje.push("Población (máx. 80 caracteres)");
      }
      if (!this.cliente.remite.cp) {
        this.validaMensaje.push("Código Postal (máx. 5 dígitos)");
      }
      return this.validaMensaje.length == 0;
    },
    listar() {
      console.log("listar");
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("cliente/list", configuracion)
        .then(function(response) {
          console.log("response", response);
          me.validaMensaje = [];
          me.clientes = response.data;
          console.log("listar me.clientes", me.clientes);
        })
        .catch(function(error) {
          console.log(error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    abrirNuevoCliente() {
      this.validaMensaje = [];
      this.dialog = true;
    },
    editarCliente(item) {
      console.log("editar", item);
      this.cliente = Object.assign({}, item);
      if (!this.cliente.uid_WSTransportista) {
        this.cliente.uid_WSTransportista = { gls: "" };
      }
      this.accion = EDITANDO;
      this.validaMensaje = [];
      this.dialog = true;
    },
    confirmarEliminarCliente(item) {
      console.log("confirmarEliminarCliente", item);
      this.cliente = Object.assign({}, item);
      this.accion = ELIMINANDO;
      this.validaMensaje = [];
      this.dialog = true;
    },
    insertarCliente() {
      let me = this;
      let header = { Token: me.$store.state.token };
      let configuracion = { headers: header };
      if (!this.esValido()) {
        return;
      }
      axios
        .post(
          "cliente/add",
          {
            codigo: me.cliente.codigo,
            nombre_comercial: me.cliente.nombre_comercial,
            uid_WSTransportista: {
              gls: me.cliente.uid_WSTransportista.gls
            },
            remite: me.cliente.remite
          },
          configuracion
        )
        .then(function(response) {
          console.log("response", response);
          me.limpiar();
          me.cerrar();
          me.listar();
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    actualizarCliente() {
      let me = this;
      let header = { Token: me.$store.state.token };
      let configuracion = { headers: header };
      if (!me.esValido()) {
        return;
      }
      axios
        .put("cliente/update", me.cliente, configuracion)
        .then(function(response) {
          me.limpiar();
          me.cerrar();
          me.listar();
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    eliminarCliente() {
      let me = this;
      let header = { Token: me.$store.state.token };
      console.log("me._id", me.cliente._id);
      axios
        .delete("cliente/remove/", {
          data: { _id: me.cliente._id },
          headers: header
        })
        .then(function(response) {
          me.limpiar();
          me.cerrar();
          me.listar();
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    activar(item) {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("cliente/activate", { _id: item._id }, configuracion)
        .then(function(response) {
          me.validaMensaje = [];
          me.listar();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    desactivar(item) {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("cliente/deactivate", { _id: item._id }, configuracion)
        .then(function(response) {
          me.validaMensaje = [];
          me.listar();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    exportarClientes2Excel() {
      console.log("exportarClientes2Excel");
      try {
        let clientes = [];
        this.clientes.forEach(c => {
          clientes.push({
            "Código": c.codigo,
            "Nombre comercial": c.nombre_comercial,
            "Provincia": c.remite.provincia,
            "Población": c.remite.poblacion,
            "Teléfono": c.remite.telefono,
            "Móvil": c.remite.movil,
            "Email": c.remite.email
          });
        });
        let worksheet = XLSX.utils.json_to_sheet(clientes);
        let new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "clientes");
        XLSX.writeFile(new_workbook, "clientes.xlsx");
      } catch (error) {
        console.error("export error", error);
      }
    },
    cerrar() {
      this.dialog = false;
      this.limpiar();
    }
  }
};
</script>


<style scoped>
.v-text-field {
  padding-top: 0px;
}
</style>
